// trackingApiUrlMap is not exported from @qubictron/url — Road search API disabled for now.
// import { trackingApiUrlMap } from "@qubictron/url";
import axios from "axios";
import { RoadQueryParams } from "./query.types";
import { RoadResponseDTO } from "./response.types";
import { injectAuthHeader, injectDataInterceptor } from "shared/api/utils/api.utils";

// const TRACKING_URL = trackingApiUrlMap
//   .prod()
//   .setPathname("road")
//   .handleQueryParams((qp) => {
//     qp.set("api_key", "1");
//     qp.set("path", "true");
//   })
//   .build();
const TRACKING_URL = "";

const requestInstance = axios.create();
requestInstance.defaults.baseURL = TRACKING_URL;
injectDataInterceptor(requestInstance);
injectAuthHeader(requestInstance);

class RoadSearchService {
  public search(params: RoadQueryParams, signal?: AbortSignal): Promise<RoadResponseDTO> {
    return requestInstance.get("", {
      params,
      ...(signal ? { signal } : {}),
    });
  }
}

export const roadSearchService = new RoadSearchService();
